import React from 'react'
import ReportWrapper from '../ReportWrapper'
import PageEmpty from '../../../components/PageEmpty'
import RongdataEducationalInformationOverview from './RongdataEducationalInformationOverview'
import EducationItem from './EducationItem'
import { Stack, Text } from '@mantine/core'
import { useTheme } from '../../../components/ThemeProvider'
import ReportSectionHeading from '../ReportSectionHeading'

interface RongdataEducationalInformationProps {
  data: any
  title: string
  sectionIndex?: string
}

export default function RongdataEducationalInformation({
  data,
  title,
  sectionIndex,
}: RongdataEducationalInformationProps) {
  const theme = useTheme()

  let educationList: any[]

  try {
    const parsedData =
      typeof data.rongdata_education_info === 'string'
        ? JSON.parse(data.rongdata_education_info || '{}')
        : data.rongdata_education_info || {}

    educationList = parsedData?.items ?? []
  } catch (error) {
    console.error('Failed to parse rongdata_education_info:', error)
    educationList = []
  }

  return (
    <ReportWrapper>
      <ReportSectionHeading title={title} index={sectionIndex} />
      {educationList.length > 0 && <RongdataEducationalInformationOverview educationList={educationList} />}
      <div className="mt-2">
        <Text size="sm" fw={600} style={{ color: theme.accentTextColor }}>
          教育经历
        </Text>
        <Stack gap="sm" className="mt-3">
          {educationList.length === 0 ? (
            <PageEmpty />
          ) : (
            educationList.map((item: any, index: number) => {
              return <EducationItem number={index + 1} key={index} item={item} />
            })
          )}
        </Stack>
      </div>
    </ReportWrapper>
  )
}
